import { useEffect, useState } from "react";

import { updateSocialSettings } from "../../services/settingsApi";

function SocialSettings({ settings, reload }) {

    const [formData, setFormData] = useState({
        facebook: "",
        instagram: "",
        twitter: "",
        youtube: "",
        linkedin: "",
    });

    useEffect(() => {

        if (settings) {

            setFormData({
                facebook: settings.facebook || "",
                instagram: settings.instagram || "",
                twitter: settings.twitter || "",
                youtube: settings.youtube || "",
                linkedin: settings.linkedin || "",
            });

        }

    }, [settings]);

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await updateSocialSettings(formData);

            alert("Social settings updated successfully.");

            reload();

        } catch (error) {

            console.error(error);

            alert("Failed to update social settings.");

        }

    };

    return (

        <form
            className="settings-form"
            onSubmit={handleSubmit}
        >

            <div className="settings-card">

                <h2>Social Media Settings</h2>

                <div className="settings-grid">

                    <div className="form-group">

                        <label>Facebook URL</label>

                        <input
                            type="url"
                            name="facebook"
                            value={formData.facebook}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>Instagram URL</label>

                        <input
                            type="url"
                            name="instagram"
                            value={formData.instagram}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>Twitter / X URL</label>

                        <input
                            type="url"
                            name="twitter"
                            value={formData.twitter}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>YouTube URL</label>

                        <input
                            type="url"
                            name="youtube"
                            value={formData.youtube}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>LinkedIn URL</label>

                        <input
                            type="url"
                            name="linkedin"
                            value={formData.linkedin}
                            onChange={handleChange}
                        />

                    </div>

                </div>

                <button
                    type="submit"
                    className="save-btn"
                >
                    Save Social Settings
                </button>

            </div>

        </form>

    );

}

export default SocialSettings;